import moment from 'moment';
import '../../assignmentCalendar/AssignmentCalendar.scss';
import { MAX_EVENTS_PER_DAY } from './common';

// Custom "show more" component that only counts events starting on the current date
export const CustomShowMore = (props) => {
    const {
        localizer,
        slotDate,
        events, // ALL events for this slot
        onShowMore, // Passed from parent component
    } = props;

    // Filter to only events that start on this date
    const eventsStartingToday = events.filter((event) =>
        moment(event.start).isSame(slotDate, 'day'),
    );

    // Calculate the number of HIDDEN events that START TODAY
    const max = MAX_EVENTS_PER_DAY; // This was due to how the calendar handles height
    const hiddenCount = Math.max(0, events.length - max);

    // Don't show the "show more" link if all events starting today are visible
    if (hiddenCount === 0) {
        return null;
    }

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Call the calendar's onShowMore handler with the filtered events
        if (onShowMore) {
            onShowMore(eventsStartingToday, slotDate);
        }
    };

    return (
        <button
            type="button"
            className="rbc-show-more"
            onClick={handleClick}
        >
            {localizer.messages.showMore(hiddenCount, eventsStartingToday, events)}
        </button>
    );
};
